import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, Protected } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Confirmations from "@/pages/Confirmations";
import Production from "@/pages/Production";
import Materials from "@/pages/Materials";
import Products from "@/pages/Products";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Deliveries from "@/pages/Deliveries";
import Credit from "@/pages/Credit";
import Insights from "@/pages/Insights";
import Team from "@/pages/Team";
import SettingsPage from "@/pages/Settings";
import Join from "@/pages/Join";
import Signups from "@/pages/Signups";
import Offers from "@/pages/Offers";
import Bugs from "@/pages/Bugs";
import Societies from "@/pages/Societies";
import Leads from "@/pages/Leads";
import MyCustomers from "@/pages/MyCustomers";
import StallSales from "@/pages/StallSales";
import Purchasing from "@/pages/Purchasing";
import Launches from "@/pages/Launches";
import LaunchPublic from "@/pages/LaunchPublic";
import Accounts from "@/pages/Accounts";
import Gst from "@/pages/Gst";
import DeliveryApp from "@/pages/DeliveryApp";
import Portal from "@/pages/Portal";
import Invoice from "@/pages/Invoice";

const admin = (el) => <Protected roles={["admin"]}>{el}</Protected>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/join" element={<Join />} />
          <Route path="/join/:token" element={<Join />} />
          <Route path="/c/:token" element={<Portal />} />
          <Route path="/c/:token/:tab" element={<Portal />} />
          <Route path="/launch/:id" element={<LaunchPublic />} />
          <Route path="/delivery" element={<Protected roles={["delivery", "admin"]}><DeliveryApp /></Protected>} />
          <Route path="/invoice/:orderId" element={<Protected roles={["admin", "production"]}><Invoice /></Protected>} />
          <Route element={<Protected roles={["admin", "production", "qa", "sales", "accountant"]}><Layout /></Protected>}>
            <Route path="/gst" element={<Protected roles={["admin", "accountant"]}><Gst /></Protected>} />
            <Route path="/accounts" element={<Protected roles={["admin", "accountant"]}><Accounts /></Protected>} />
            <Route path="/leads" element={<Protected roles={["admin", "sales"]}><Leads /></Protected>} />
            <Route path="/my-customers" element={<Protected roles={["sales", "admin"]}><MyCustomers /></Protected>} />
            <Route path="/stall-sales" element={<Protected roles={["admin", "production"]}><StallSales /></Protected>} />
            <Route path="/purchasing" element={<Protected roles={["admin", "production"]}><Purchasing /></Protected>} />
            <Route path="/launches" element={admin(<Launches />)} />
            <Route path="/bugs" element={<Protected roles={["admin", "qa"]}><Bugs /></Protected>} />
            <Route path="/" element={admin(<Dashboard />)} />
            <Route path="/confirmations" element={<Confirmations />} />
            <Route path="/production" element={<Production />} />
            <Route path="/materials" element={<Materials />} />
            <Route path="/products" element={admin(<Products />)} />
            <Route path="/customers" element={admin(<Customers />)} />
            <Route path="/customers/:id" element={admin(<CustomerDetail />)} />
            <Route path="/deliveries" element={admin(<Deliveries />)} />
            <Route path="/credit" element={admin(<Credit />)} />
            <Route path="/insights" element={admin(<Insights />)} />
            <Route path="/team" element={admin(<Team />)} />
            <Route path="/settings" element={admin(<SettingsPage />)} />
            <Route path="/signups" element={admin(<Signups />)} />
            <Route path="/offers" element={admin(<Offers />)} />
            <Route path="/societies" element={admin(<Societies />)} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
